import script from "./ModalRegistrarPartida.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalRegistrarPartida.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__